module.exports = __webpack_public_path__ + "img/credit-card-plus.4c374c4e.svg";